import { CoordinateEmpty, CoordinateSchema } from "$lib/data/schema/coordinate"
import { RelationEmpty, RelationSchema } from "$lib/data/schema/_relation"
import { z } from "zod/v4"

export type { Relation } from "$lib/data/schema/_relation"

export const CustomerSchema = z.object({
  id: z.number().default(0),
  number: z.string().default(""),
  name: z.string().default(""),
  category: RelationSchema.default(RelationEmpty),
  contact_name: z.string().default(""),
  group_customer: z.string().default(""),
  contact_phone: z.string().default(""),
  contact_email: z.string().default(""),
  province: RelationSchema.default(RelationEmpty),
  city: RelationSchema.default(RelationEmpty),
  address: z.string().default(""),
  coordinate: CoordinateSchema.default(CoordinateEmpty),
  radius: z.number().default(0),
  config_discount_percentage: z.number().default(0),
  status: z.boolean().default(true),
})

export type Customer = z.infer<typeof CustomerSchema>
export const CustomerEmpty = CustomerSchema.parse({})
